/* globals I18n */
import React, { useState, useEffect } from "react";
import paginate from "Utils/paginate";
import Shop from "Components/Shop";
import { getDesc } from "Components/Shop/helpers";

const LoadingSpinner = () => (
  <div className="flex items-center justify-center py-16">
    <div
      className="technet-spinner"
      role="status"
      aria-label={I18n.t("loading")}
    />
  </div>
);

const SearchResults = ({
  shops = [],
  query = "",
  radius = 20,
  isLoading = false,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [currentDesc, setCurrentDesc] = useState(getDesc(shops, query, radius));

  useEffect(() => {
    setCurrentPage(1);
    setCurrentDesc(getDesc(shops.length, query, radius));
  }, [shops, query, radius]);

  const { pages, startIndex, endIndex, totalPages } = paginate({
    totalResults: shops.length,
    currentPage,
  });

  const paginatedShops = shops.slice(startIndex, endIndex + 1);

  return (
    <div className="container mx-auto p-8 bg-brand-lightgray shadow">
      <h2 className="font-sans font-bold text-brand-blue text-xl">
        {currentDesc}
      </h2>

      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <div id="pagination" className="pagination flex lg:justify-end pt-4">
            {currentPage > 1 && (
              <div>
                <div
                  className="bg-brand-red hover:bg-brand-redhighlight text-sm text-white py-1 px-2 m-1 rounded cursor-pointer"
                  type="button"
                  onClick={() =>
                    currentPage > 1 && setCurrentPage(currentPage - 1)
                  }
                >
                  {I18n.t("previous")}
                </div>
              </div>
            )}

            {pages.map((page) => (
              <div
                key={page}
                className={`bg-brand-${page === currentPage ? "red" : "blue"} hover:bg-brand-redhighlight text-sm text-white py-1 px-2 m-1 rounded cursor-pointer`}
                type="button"
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </div>
            ))}

            <div>
              <div
                className="bg-brand-red hover:bg-brand-redhighlight text-sm text-white py-1 px-2 m-1 rounded cursor-pointer"
                type="button"
                onClick={() =>
                  currentPage < totalPages && setCurrentPage(currentPage + 1)
                }
              >
                {I18n.t("next")}
              </div>
            </div>
          </div>

          <div className="flex flex-wrap justify-between gap-4 pt-8">
            {paginatedShops.map((shop, index) => (
              <Shop {...shop} key={index + shop.shop_name} />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SearchResults;
